import { render } from "./AppHeader.vue?vue&type=template&id=08839435&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=08839435&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08839435"]])

export default __exports__